<template>
    <div class='fxn-header-left'>
        <div class="fxn-pull-left" v-if="hasSeat != 0 && seats.length > 0">
            <div v-if="$store.state.isRegistered">
                <div v-if="!$store.state.iscalling && !$store.state.isincall">
                    <el-form :model="TelForm" :rules="TelRules" ref="TelForm">
                        <el-form-item class="fxn-header-input" label="" prop="phone">
                            <input class="el-input__inner" type="text" v-model="TelForm.phone" autocomplete="off" maxlength="12" placeholder="请输入电话号码">
                        </el-form-item>
                        <div class="fxn-header-button">
                            <el-button type="success" style="min-width: 32px;height: 36px;" icon="iconfont iconzxgl" @click="submitTel('')"></el-button>
                        </div>
                    </el-form>
                </div>
                <span v-else-if="$store.state.iscalling">
                    通话中
                    <el-button type="danger" style="min-width: 32px;height: 36px;" icon="iconfont iconphone-off" @click="submitEnd"></el-button>
                </span>
                <span v-else-if="$store.state.isincall">
                    来电通话中
                    <el-button type="danger" style="min-width: 32px;height: 36px;" icon="iconfont iconphone-off" @click="submitEnd"></el-button>
                </span>
            </div>
            <div v-else>
                未登录坐席服务
            </div>
        </div>
        <div class="fxn-pull-left" v-else>
            <span v-if="mem_type == '2'">联系本公司运营人员分配坐席</span>
        </div>
        <!-- 坐席呼叫 End -->

        <div class="fxn-pull-left fxn-Header-Data" v-if="mem_type == '2'">
            <div class="item">总案件：<span>{{TopDatas.case_num}}</span></div>
            <div class="item">总金额：<span>{{TopDatas.case_money | Money}}万</span></div>
            <div class="item">回款金额：<span>{{TopDatas.repay_money | Money}}万</span></div>
            <div class="item">剩余金额：<span>{{TopDatas.surplus_money | Money}}万</span></div>
        </div>
        <!-- 数据统计 End -->

        <ServiceItem></ServiceItem>   
        <!-- 服务项 End --> 
    </div>
</template>

<script>
    import {loadFile} from '../api/utils'
    import ServiceItem from './ServiceItem'
    export default {
        components: {
            ServiceItem,
        },
        data(){
            return{
                seats: [],
                hasSeat: '',
                mem_type: '',
                TopDatas: {},

                //呼叫
                TelForm: {
                    phone: '',
                },
                TelRules: {},
            }
        },
        methods:{
            //呼叫
            submitTel(phone,case_id){
                let reg = /(\w{3})\w*(\w{4})/;
                let callPhone = '';
                if(phone){
                    callPhone = phone;
                }else{
                    callPhone = this.TelForm.phone;
                }
                if(!callPhone){
                    this.$message.error('请输入电话号码');
                    return false;
                }
                let params = (case_id ? case_id : 0) + '|0';
                webrtcSDK.callPhone({
                    phone: callPhone,
                    params: params, //字符串类型 案件ID｜联系人ID '13058|0' 竖杠分隔 
                    // encodphone: callPhone.replace(reg,'$1****$2'),
                    // encoding: false
                })
            },

            //挂机
            submitEnd(){
                webrtcSDK.endCall();
            },

            //数据统计
            topData(){
                this.get('/osapi/Cases/casesSelfStatic')
                .then(res=>{
                    let { msg, code, data } = res.data
                    if(code !== 1){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.TopDatas = res.data.data
                    }
                })
            },
        },
        mounted(){
            //获取已登录用户信息
            let user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                this.mem_type = user.memberInfo.mem_type;
                this.hasSeat = user.memberInfo.hasSeat;
                this.seats = user.memberInfo.seats;
            }

            //WebRTC
            if(user.memberInfo.hasSeat != 0 && (this.seats.length > 0 || this.seats != [])){
                let option = {
                    fixedTop: 85,   //按钮距离顶部距离
                    autoLogin: true,
                    user: this.seats[0].voipaccount,
                    password: this.seats[0].voippwd,
                }
                loadFile(this.webURL + '/webrtcSDK.umd.min.js')
                .then((res)=>{
                    webrtcSDK.init(option,(e) =>{
                        this.$store.commit('SET_IS_REGISTERED',e.isRegistered);
                        this.$store.commit('SET_IS_CALLING',e.iscalling);
                        this.$store.commit('SET_IS_IN_CALL',e.isincall);
                    })
                })
            }

            //获取父子页面呼叫传参
            let that = this;
            this.OpenAside.$on('toTel',function(case_phone,case_id,type,calltype,seatid){
                that.submitTel(case_phone,case_id);
            })

            //请求数据
            this.topData();
        }
    }
</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/WebRTC.vue